/**
 * Parsea el body de una Response como JSON. Si llega HTML (p. ej. Vite sin API en /api),
 * lanza un error con instrucciones para levantar el servidor Express.
 */
export async function readJsonResponse(res: Response): Promise<unknown> {
  const text = await res.text();
  if (!text.trim()) return {};
  try {
    return JSON.parse(text) as unknown;
  } catch {
    const ct = (res.headers.get("content-type") ?? "").toLowerCase();
    const looksHtml = ct.includes("text/html") || /^\s*</.test(text);
    if (looksHtml) {
      throw new Error(
        `El servidor devolvió HTML en lugar de JSON (HTTP ${res.status}). ` +
          "Con solo «npm run dev», Vite no ejecuta /api: en otra terminal corré «npm run dev:server» " +
          "(Express en :3000) y definí VITE_DEV_API_PROXY=http://127.0.0.1:3000 en .env.local, " +
          "o usá «npm start» que levanta SPA + API juntos en :8080.",
      );
    }
    throw new Error(`El servidor no devolvió JSON válido (HTTP ${res.status}).`);
  }
}

/** Mensaje de error típico de APIs `{ error?: string }` o `{ message?: string }`. */
export function apiErrorMessage(data: unknown, fallback: string): string {
  if (data !== null && typeof data === "object" && !Array.isArray(data)) {
    const o = data as { error?: unknown; message?: unknown };
    if (typeof o.message === "string" && o.message.trim()) return o.message;
    if (typeof o.error === "string" && o.error.trim()) return o.error;
  }
  return fallback;
}
